import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';
import { createOrUpdateProfile, consumePendingRegistration } from '../services/authProfile';

const AuthListener = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!supabase) return;

    const handleSession = async (session) => {
      if (!session) return;
      try {
        const email = session.user?.email || '';
        const pendingMeta = consumePendingRegistration(email) || {};
        const profile = await createOrUpdateProfile({
          full_name: pendingMeta.full_name,
          organization: pendingMeta.organization,
          role: pendingMeta.role,
          phone: pendingMeta.phone,
          email
        });

        if (profile?.role === 'hr') {
          navigate('/hr-dashboard', { replace: true });
        } else if (profile?.role === 'spoc') {
          navigate('/spoc-dashboard', { replace: true });
        } else {
          // Fallback: stay on current page or go home
          if (location.pathname === '/login' || location.pathname === '/register') {
            navigate('/', { replace: true });
          }
        }
      } catch (error) {
        console.error('Auth session handling failed', error);
      }
    };

    const init = async () => {
      const { data, error } = await supabase.auth.getSession();
      if (!error && data?.session) {
        await handleSession(data.session);
      }
    };

    init();

    const { data: listener } = supabase.auth.onAuthStateChange(async (_event, session) => {
      await handleSession(session);
    });

    return () => {
      listener?.subscription?.unsubscribe();
    };
  }, [navigate, location.pathname]);

  return null;
};

export default AuthListener;
